import getServiceItemIds from 'owa-mail-store/lib/services/utils/getServiceItemIds';
import ReportMessageToSafetyLibraryRequest from 'owa-service/lib/contract/ReportMessageToSafetyLibraryRequest';
import SafetyApiAction from 'owa-service/lib/contract/SafetyApiAction';
import reportMessageToSafetyLibraryOperation from 'owa-service/lib/operation/reportMessageToSafetyLibraryOperation';

/**
 * Report the message to safety library service
 * @param itemIds the itemIds to update
 * @param safetyApiAction the safetyApiAction type
 * @param actionData the action data
 * @return the ReportMessageToSafetyLibraryResponse
 */
export default function reportMessageToSafetyLibraryService(
    itemIdsToUpdate: string[],
    safetyApiAction: SafetyApiAction,
    actionData?: number[]
): Promise<boolean> {
    const requestBody: ReportMessageToSafetyLibraryRequest = {
        ItemIds: getServiceItemIds(itemIdsToUpdate),
        ReportAction: safetyApiAction,
    };

    if (actionData) {
        requestBody.ActionData = actionData;
    }

    return reportMessageToSafetyLibraryOperation(requestBody)
        .then(response => {
            return response.ReportSucccess[0];
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
